import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import {
  CONTROLLERS_PATH,
  controllerFilesPath,
  controllerHardwarePath,
  readControllerId,
  rememberedControllerId,
} from './paths';

const RedirectWithSearch: React.FC<{ to: string }> = ({ to }) => {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
};

export const RedirectDeviceDetail: React.FC = () => {
  const { deviceId } = useParams();
  return <Navigate to={`${CONTROLLERS_PATH}/${encodeURIComponent(deviceId || '')}`} replace />;
};

export const RedirectLegacyHardware: React.FC = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const id = readControllerId(params) || rememberedControllerId();
  if (!id) {
    return <Navigate to={CONTROLLERS_PATH} replace />;
  }
  return <Navigate to={controllerHardwarePath(id, params.get('instance') || undefined)} replace />;
};

export const RedirectLegacyFiles: React.FC = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const kind = params.get('kind');
  const storedId = params.get('id') || '';
  const controllerId = kind === 'template'
    ? rememberedControllerId()
    : (readControllerId(params) || rememberedControllerId());
  if (!controllerId) {
    return <Navigate to={CONTROLLERS_PATH} replace />;
  }
  const next = new URLSearchParams();
  if (kind === 'template' && storedId) {
    next.set('kind', 'template');
    next.set('id', storedId);
  } else {
    next.set('kind', 'device');
    next.set('id', controllerId);
  }
  const path = params.get('path');
  if (path) {
    next.set('path', path);
  }
  return <Navigate to={`${controllerFilesPath(controllerId)}?${next.toString()}`} replace />;
};

export default RedirectWithSearch;
